import { CrossPostConfig } from "@voxmedia/duet-context/context/config-context";

export const CROSS_POST_CONFIG: CrossPostConfig = [
  {
    name: "The Strategist",
    host: "nymag.com",
    path: "/strategist",
    url: "https://nymag.com/strategist",
  },
  {
    name: "Intelligencer",
    host: "nymag.com",
    path: "/intelligencer",
    url: "https://nymag.com/intelligencer",
  },
  {
    name: "New York Magazine",
    host: "nymag.com",
    url: "https://nymag.com/",
  },
  {
    name: "Vulture",
    host: "vulture.com",
    url: "https://www.vulture.com/",
  },
  {
    name: "Grub Street",
    host: "grubstreet.com",
    url: "https://www.grubstreet.com/",
  },
  {
    name: "The Cut",
    host: "thecut.com",
    url: "https://www.thecut.com/",
  },
  {
    name: "Curbed",
    host: "curbed.com",
    url: "https://www.curbed.com/",
  },
  {
    name: "Punch",
    host: "punchdrink.com",
    url: "https://www.punchdrink.com/",
  },
  {
    name: "Thrillist",
    host: "thrillist.com",
    url: "https://www.thrillist.com/",
  },
  {
    name: "The Dodo",
    host: "thedodo.com",
    url: "https://www.thedodo.com/",
  },
  {
    name: "Popsugar",
    host: "popsugar.com",
    url: "https://www.popsugar.com/",
  },
  {
    name: "Now This",
    host: "nowthisnews.com",
    url: "https://www.nowthisnews.com/",
  },
  {
    name: "The Verge",
    host: "theverge.com",
    url: "https://www.theverge.com/",
  },
  {
    name: "Eater",
    host: "eater.com",
    url: "https://www.eater.com/",
  },
  {
    name: "SBNation",
    host: "sbnation.com",
    url: "https://www.sbnation.com/",
  },
  {
    name: "Punch",
    host: "punchdrink.com",
    url: "https://www.punchdrink.com/",
  },
];

export const crossPostConfigForCommunity = (
  communityName: string,
): CrossPostConfig => {
  // Exclude the current community from the config
  return CROSS_POST_CONFIG.filter((c) => c.name !== communityName);
};
